;(function () {
  'use strict'

  angular
    .module('contrast.server')
    .controller('ServerNotesCtrl', ServerNotesCtrl)

  function ServerNotesCtrl($scope, currentServerService, UserService) {
    'ngInject'

    var _getServerOptions = { buildDotNet: true }

    angular.extend($scope, {
      server: {},
      model: {
        busy: false
      }
    })

    angular.extend($scope, {
      getPoolBitness: getPoolBitness,
      getPipelineMode: getPipelineMode,
      getAppByName: getAppByName,
      getOrg: getOrg,
      printNameIfNotTracked: printNameIfNotTracked,
      isBusy: isBusy,
      showApplicationPools: showApplicationPools,
      hasNotesData: hasNotesData
    })

    function init() {
      $scope.model.busy = true

      // No reason to listen to the currentServerService.onChange in this controller
      // because this controller is instantiated each time the tab it is associated with is accessed
      // and it is destroyed when another tab is rendered. We also don't have any write operations
      // for a server in here - if we did, then we would add the onChange listener.
      currentServerService
        .get(false, _getServerOptions)
        .then(function (server) {
          $scope.server = server
        })
        .finally(function () {
          $scope.model.busy = false
        })
    }

    function isBusy() {
      return $scope.model.busy
    }

    function getPoolBitness(pool) {
      if (pool) {
        return pool.x64 ? '64-bit' : '32-bit'
      }
      return null
    }

    function getPipelineMode(pool) {
      if (pool) {
        return pool.integratedPipelineMode ? 'Integrated' : 'Classic'
      }
      return null
    }

    function getAppByName(appName) {
      return _.find($scope.server.applications, function (item) {
        return item.name == appName
      })
    }

    function getOrg() {
      return UserService.getCurrentOrganization()
    }

    function printNameIfNotTracked(appName) {
      return !getAppByName(appName) ? appName : null
    }

    // Only show if all pools have a name
    function showApplicationPools() {
      return (
        $scope.server.serverProperties.custom &&
        $scope.server.serverProperties.custom.appPools &&
        _.every(
          $scope.server.serverProperties.custom.appPools,
          function (pool) {
            return angular.isString(pool.name) && pool.name.trim().length
          }
        )
      )
    }

    function hasNotesData() {
      return (
        ($scope.server.serverProperties &&
          $scope.server.serverProperties.custom &&
          $scope.server.serverProperties.custom.appPools) ||
        ($scope.server.formattedProperties &&
          ($scope.server.formattedProperties.clrVersion ||
            $scope.server.formattedProperties.processor ||
            $scope.server.formattedProperties.memory))
      )
    }

    init()
  }
})()
